import ImportedGoodCustomsStatusForm from './ImportedGoodCustomsStatusForm'
import { ImportedGoodFormData } from './ImportedGoodForm.schema'
import ImpordedGoodDetailsForm from './ImportedGoodDetailsForm'
import { GoodsFamily } from '@/common'
import ImportedGoodImporterSelectForm from './ImportedGoodImporterSelectForm'
import ImportedGoodSupplierEmissionsForm from './ImportedGoodSupplierEmissionsForm'
import { Partnership } from '@/features/suppliers/hooks/partnerships'
import { Installation } from '@/features/suppliers/hooks/installations'
import { SupplierEmissionsReport } from '@/features/suppliers/hooks/supplierEmissionsReport'
import type { GetAggregatedCategoryForCnCode } from '@/shared/utils/batchUpdateSelectionRules'

type ImportedGoodFormProps = {
  organizationId: string
  data: ImportedGoodFormData
  onChange: (data: ImportedGoodFormData) => void
  isUsingDefaultEmissions?: boolean
  goodsFamily?: GoodsFamily
  isRepresentative: boolean
  getAggregatedCategoryForCnCode?: GetAggregatedCategoryForCnCode
  partnerships?: Partnership[]
  installations?: Installation[]
  emissionsReports?: SupplierEmissionsReport[]
  hasSelectedInstallation?: boolean
  isEditMode?: boolean
  periodId: string
  cbamReportYear?: number
}

export default function ImportedGoodForm({
  organizationId,
  data,
  onChange,
  isUsingDefaultEmissions = false,
  goodsFamily,
  isRepresentative,
  getAggregatedCategoryForCnCode,
  partnerships,
  installations,
  emissionsReports,
  hasSelectedInstallation,
  isEditMode = false,
  periodId,
  cbamReportYear
}: ImportedGoodFormProps) {
  const allInstallations = installations ?? []
  const allPartnerships = partnerships ?? []
  const allEmissionsReports = emissionsReports ?? []

  return (
    <div className="space-y-6 pb-2">
      {getAggregatedCategoryForCnCode && (
        <ImportedGoodSupplierEmissionsForm
          data={data}
          onChange={onChange}
          partnerships={allPartnerships}
          installations={allInstallations}
          emissionsReports={allEmissionsReports}
          getAggregatedCategoryForCnCode={getAggregatedCategoryForCnCode}
          isEditMode={isEditMode}
          cbamReportYear={cbamReportYear}
        />
      )}
      {isRepresentative && (
        <ImportedGoodImporterSelectForm
          organizationId={organizationId}
          data={data}
          onChange={onChange}
        />
      )}
      <ImpordedGoodDetailsForm
        data={data}
        goodsFamily={goodsFamily}
        onChange={onChange}
        isUsingDefaultEmissions={isUsingDefaultEmissions}
        hasSelectedInstallation={hasSelectedInstallation ?? false}
        periodId={periodId}
      />
      <ImportedGoodCustomsStatusForm data={data} onChange={onChange} />
    </div>
  )
}
